module.exports = __webpack_public_path__ + "static/media/helper_icon.605a83c8.svg";